module.exports = __webpack_public_path__ + "static/Mailmerge-scot.74dc0814.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Mailmerge-scot.jpg
// module id = 505
// module chunks = 153228935106781